
// Components:
import Navbar from "../components/navbar"
import Hero from "../components/home/hero"
import Features from "../components/home/features"
import Services from "../components/home/services"
import Pedagogy from "../components/home/pedagogy"
import Partners from "../components/home/partners"
import Contact from "../components/home/contact"

const Home = () => {
    return <>
        <Navbar/>
        <Hero />
        <Features />
        <Services />
        <Pedagogy />
        <Partners />
        <Contact />
        </>
}

export default Home